var $8f643aac2e9e9e26$exports = {};
$8f643aac2e9e9e26$exports = {
    "help": `\u{30D8}\u{30EB}\u{30D7}`,
    "info": `\u{60C5}\u{5831}`
};


export {$8f643aac2e9e9e26$exports as default};
//# sourceMappingURL=ja-JP.module.js.map
